import Location from "../../hooks/Location";
import DeccaTriggerButton from "../common/DeccaTriggerButton.jsx";

/**
 * @param {object} props
 * @param {string} props.heading - The page title.
 * @param {string} [props.subHeading] - Optional sub-title under the heading.
 * @param {string} [props.description] - Optional description row text.
 * @param {boolean} [props.AI] - When true, shows the "Vraag Decca om advies" button.
 * @param {React.ReactNode} [props.actions] - Optional action buttons in the title row.
 * @param {string} [props.deccaSubject] - Overrides the Decca conversation subject (defaults to the page name).
 * @param {string} [props.deccaGreeting] - Custom HTML opening message for Decca (defaults to the generic greeting).
 */
const PageHeader = ({heading, subHeading, description, AI, actions, deccaSubject, deccaGreeting}) => {
    const pageName = Location()[2];

  return (
    <div className="page-header-new">
        <div id='page-header-title-container'>
            <div id='page-header-title-container-text'>
                <h1>{heading}</h1>
                {subHeading && <p>{subHeading}</p>}
            </div>
            {actions && (
                <div id='page-header-title-container-actions'>
                    {actions}
                </div>
            )}
        </div>
        {(description || AI) && (
            <div id='page-header-description-row'>
                {description
                    ? <p id='page-header-description-text'>{description}</p>
                    : <span />
                }
                {AI && <DeccaTriggerButton subject={deccaSubject || pageName} greeting={deccaGreeting} />}
            </div>
        )}
    </div>
  )
}

export default PageHeader